var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('sqr-hero',{attrs:{"short":"invoice_add","color":"light","is-bold":"","size":"medium","is-loading":_vm.adding}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }